const React = require('react');
const $ = require('jquery');
const ReactDOM = require('react-dom');

module.exports = React.createClass({
	
	getNode(){
		return $(ReactDOM.findDOMNode(this));
	},

	componentDidMount(){
		this.getNode().on('hidden.bs.modal',this.onModalClose);
		this.getNode().on('show.bs.modal',this.onModalShow);
	},

	componentWillUmount(){
		this.getNode().unbind('hidden.bs.modal',this.onModalClose);
		this.getNode().unbind('show.bs.modal',this.onModalShow);
	},

	onModalClose(){
		if (this.props.onModalClose) this.props.onModalClose();
	},

	onModalShow(){
		if (this.props.onModalShow) this.props.onModalShow();
	},

	show(){
		this.getNode().modal('show');
	},

	hide(){
		this.getNode().modal('hide');
	},

	render(){
		var btnClass = this.props.btnClass || 'primary';

		var okButton;

		if (this.props.onConfirm) {
			okButton = <button type='button' className={'btn btn-'+btnClass} onClick={this.props.onConfirm} >Ok</button>;
		}

		return (	
			<div className='modal fade'>
			  <div className={'modal-dialog'+((this.props.large) ? ' modal-lg' : '')}>
			    <div className='modal-content'>
			      <div className='modal-header'>
			        <button type='button' className='close' aria-label='Close' data-dismiss='modal'><span aria-hidden='true'>&times;</span></button>
			        <h3 className='modal-title'>{this.props.title}</h3>
			      </div>
			      <div className='modal-body'>
			        {this.props.children}
			      </div>
			      <div className='modal-footer'>
							{this.props.otherButtons}
							{okButton}
			        <button type='button' className='btn btn-default' data-dismiss='modal'>Cancelar</button>
			      </div>
			    </div>
			  </div>
			</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/dialog.js
 **/